module.exports = __webpack_public_path__ + "static/media/specialPrice1.fe3cf461.webp";